<div *ngIf="(isMobile$ | async) === false">
  <table mat-table [dataSource]="codes">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">
        <a
          [routerLink]="['/inbox/thread/' + element.thread_uuid]"
          class="link-emphasized"
          data-element="guest-code-name-link"
          (click)="$event.stopPropagation()">
          {{ element.name }}
        </a>
      </td>
    </ng-container>

    <!-- Start Column -->
    <ng-container matColumnDef="start">
      <th mat-header-cell *matHeaderCellDef>Code Start</th>
      <td mat-cell *matCellDef="let element">
        {{ element.start ? (element.start | date: DATE_FORMAT) : 'Always on' }}
      </td>
    </ng-container>

    <!-- End Column -->
    <ng-container matColumnDef="end">
      <th mat-header-cell *matHeaderCellDef>Code End</th>
      <td mat-cell *matCellDef="let element">{{ element.end | date: DATE_FORMAT }}</td>
    </ng-container>

    <!-- Code Column -->
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef>Code</th>
      <td mat-cell *matCellDef="let element">
        <span
          [class]="'pincode pincode__default code-status-' + (element | codeStatusColor)"
          [matTooltip]="(element | codeStatus)?.name ?? 'Cancelled Externally'">
          {{ element.code }}
        </span>
      </td>
    </ng-container>

    <!-- Code Used Column -->
    <ng-container matColumnDef="used">
      <th mat-header-cell *matHeaderCellDef>Used</th>
      <td mat-cell *matCellDef="let element">
        <sbnb-icon
          *ngIf="element.first_used_at"
          [size]="26"
          icon="check"
          class="text-grass-darker"
          [matTooltip]="'First used at ' + (element.first_used_at | date: DATE_FORMAT)"></sbnb-icon>
      </td>
    </ng-container>

    <!-- Thermostat Setting Column -->
    <ng-container matColumnDef="thermostat-setting">
      <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap">Thermostat Setting</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex items-center gap-3" *ngIf="element.thermostat_schedules?.length > 0">
          <div class="flex items-center gap-2" *ngIf="element.thermostat_schedules?.[0]?.heating_set_point">
            <sbnb-icon icon="matches-fire" class="text-coral"></sbnb-icon>
            {{ element.thermostat_schedules?.[0]?.heating_set_point }}°F
          </div>

          <div class="flex items-center gap-2" *ngIf="element.thermostat_schedules?.[0]?.cooling_set_point">
            <sbnb-icon icon="temperature-snowflake" class="text-aqua"></sbnb-icon>
            {{ element.thermostat_schedules?.[0]?.cooling_set_point }}°F
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Current Preset Column -->
    <ng-container matColumnDef="current-preset">
      <th mat-header-cell *matHeaderCellDef>Current Preset</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex flex-col gap-6 active-preset" *ngIf="element.thermostat_schedules?.length > 0">
          {{ element.thermostat_schedules?.[0]?.preset_name }}
        </div>
      </td>
    </ng-container>

    <!-- Properties Column -->
    <ng-container matColumnDef="properties">
      <th mat-header-cell *matHeaderCellDef>{{ singleProperty ? 'Property' : 'Properties' }}</th>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="element.properties?.length > 0" fxLayoutAlign="start center" fxLayoutGap="12px">
          <ng-container *ngIf="singleProperty">
            <img class="property-img" [src]="element.property?.picture" />
            <span>{{ element.properties[0].name }}</span>
          </ng-container>

          <sbnb-avatar-group
            *ngIf="!singleProperty"
            [items]="element.properties"
            [itemsForLabel]="element.name"></sbnb-avatar-group>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="nameClicked.emit(row.reservation?.reservation_id)"></tr>
  </table>
</div>

<div *ngIf="isMobile$ | async" class="mobile-guest-table">
  <mat-card *ngFor="let code of codes; trackBy: trackCode">
    <mat-card-content (click)="nameClicked.emit(code.reservation?.reservation_id)">
      <div fxLayout="column" fxLayoutGap="12px">
        <div fxLayoutAlign="space-between center" fxLayoutGap="12px">
          <span class="strong">{{ code.name }}</span>
          <div fxLayoutAlign="start center" fxLayoutGap="12px">
            <sbnb-icon
              *ngIf="code.first_used_at"
              icon="check"
              [size]="26"
              class="text-grass-darker"
              [matTooltip]="'First used ' + (code.first_used_at | date: DATE_FORMAT)"
              #tooltip="matTooltip"
              (click)="tooltip.toggle()"></sbnb-icon>

            <span
              [class]="'pincode pincode__default code-status-' + (code | codeStatusColor)"
              [matTooltip]="'Code ' + (code | codeStatus)?.name"
              #tooltip="matTooltip"
              (click)="tooltip.toggle()"
              style="width: 70px; display: block; text-align: center">
              {{ code.code }}
            </span>
          </div>
        </div>

        <div *ngIf="singleProperty" class="ellipsis">
          {{ code.properties[0].name }}
        </div>

        <div *ngIf="!singleProperty">
          <sbnb-avatar-group [items]="code.properties" [itemsForLabel]="code.name"></sbnb-avatar-group>
        </div>

        <div *ngIf="code.start">{{ code.start | date: DATE_FORMAT }} to {{ code.end | date: DATE_FORMAT }}</div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
